// App.js

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Layout Components
import Header from "./Components/Header";
import Footer from "./Components/Footer";

// Menus
import { defaultMenu } from "./Components/menus";

// Pages
import Home from "./Components/Home";
import Courses from "./Components/Courses";
import Projects from "./Components/Projects";
import ResearchAssistance from "./Components/ResearchAssistance";
import Careers from "./Components/Careers";
import Gallery from "./Components/Gallery";
import GalleryPage from "././Components/Gallery/GalleryPage";
import ContactUs from "./Components/ContactUs";
import Publications from "./Components/Publications/publications";

// Dynamic Pages
import CourseExplore from "./Components/Courses/Explore";
import { DATA as COURSE_DATA } from "./Components/Courses/Data";
import Page404 from "./Components/404-page/Page404";
import ScrollToTop from "./Components/ScrollToTop";

function AppRoutes() {
  const menusToUse = defaultMenu;

  // Dynamic Course Routes
  const courseRoutes = Object.entries(COURSE_DATA).flatMap(
    ([catKey, subCats]) =>
      Object.entries(subCats).map(([subKey, course]) => (
        <Route
          key={`course-${catKey}-${subKey}`}
          path={`/courses/${course.name.replace(/\s+/g, "").toLowerCase()}`}
          element={<CourseExplore data={course} />}
        />
      ))
  );

  return (
    <>
      <Header menus={menusToUse} />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/contact_us" element={<ContactUs />} />
        <Route path="/research_assistance" element={<ResearchAssistance />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/gallery/:category" element={<GalleryPage />} />
        <Route path="/publications" element={<Publications />} />

        {courseRoutes}

        <Route path="*" element={<Page404 />} />
      </Routes>

      <Footer />
    </>
  );
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppRoutes />
    </Router>
  );
}
